import { Database, ShieldCheck, LineChart, Table2, Sparkles, BookOpen, ArrowUpRight, FlaskConical, ClipboardList, Scale, PenLine, Code2 } from "lucide-react";

const ICONS = { Database, ShieldCheck, LineChart, Table2, Sparkles, BookOpen, FlaskConical, ClipboardList, Scale, PenLine, Code2 };
export const SubjectIcon = ({ name, className = "h-5 w-5" }) => {
  const Icon = ICONS[name] || BookOpen;
  return <Icon className={className} />;
};

const TopicChips = ({ topics }) => (
  <div className="mt-4 flex flex-wrap gap-1.5">
    {topics.slice(0, 3).map((t) => <span key={t.id} className="rounded-full border border-line bg-canvas-2/60 px-2.5 py-1 text-[11px] text-ink-2">{t.name}</span>)}
    {topics.length > 3 && <span className="rounded-full px-2 py-1 text-[11px] text-ink-3">+{topics.length - 3} more</span>}
  </div>
);

export const SubjectCard = ({ subject, onClick, index = 0, compact = false, showTopics = false }) => (
  <button
    type="button"
    data-testid={`subject-card-${subject.id}`}
    onClick={onClick}
    style={{ animationDelay: `${index * 60}ms` }}
    className={`card-hover fade-up group relative flex h-full w-full flex-col items-start rounded-2xl border bg-surface p-6 text-left ${subject.primary ? "border-aqua/40 shadow-[inset_0_1px_0_rgb(var(--c-aqua)/0.4)]" : "border-line"}`}
  >
    <div className="flex w-full items-center justify-between gap-3">
      <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-aqua-soft text-aqua">
        <SubjectIcon name={subject.icon} />
      </span>
      <span className="flex items-center gap-2">
        {subject.primary && <span data-testid="subject-primary-badge" className="rounded-full bg-aqua-soft px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-aqua">Start here</span>}
        <span className="font-mono text-[11px] font-medium tracking-wider text-ink-3">{subject.short}</span>
      </span>
    </div>
    <h3 className="mt-5 text-lg font-bold text-ink">{subject.name}</h3>
    {!compact && <p className="mt-2 text-sm leading-relaxed text-ink-2">{subject.description}</p>}
    {showTopics && subject.topics?.length > 0 && <TopicChips topics={subject.topics} />}
    <div className="mt-auto flex w-full items-center justify-between pt-5 text-xs text-ink-3">
      <span>{subject.topics?.length || 0} topics · 3 levels</span>
      <ArrowUpRight className="h-4 w-4 text-aqua transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
    </div>
  </button>
);
